/*
 * Converts a string to title case
 * @param {string} str - The string to convert
 * @returns {string} The string in title case
 * @example
 * toTitleCase('hello_world') // 'Hello World'
 * toTitleCase('HELLO_WORLD') // 'Hello World'
 * toTitleCase('hello world') // 'Hello World'
 */
export const toTitleCase = (str?: string) => {
  if (!str) return ''

  try {
    return str
      .replace(/_/g, ' ') // Replace underscores with spaces
      .toLowerCase() // Convert to lowercase
      .split(' ') // Split into words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(' ')
  } catch {
    return str
  }
}

/*
 * Converts a string from snake_case to spaces
 * @param {string} str - The string to convert
 * @param {boolean} toLowerCase - Whether to convert the string to lowercase
 * @returns {string} The string with spaces
 * @example
 * snakeCaseToSpaces('HELLO_WORLD') // 'HELLO WORLD'
 * snakeCaseToSpaces('HELLO_WORLD', true) // 'hello world'
 */
export const snakeCaseToSpaces = (str: string, toLowerCase?: boolean) => {
  if (!str) return ''

  try {
    return toLowerCase
      ? str.replace(/_/g, ' ').toLowerCase()
      : str.replace(/_/g, ' ')
  } catch {
    return str
  }
}

/*
 * Split a string at uppercase letters and add a space
 * @param {string} str - The string to split
 * @returns {string} The string with spaces
 * @example
 * splitAtUppercaseAndAddSpace('helloWorld') // 'hello World'
 * splitAtUppercaseAndAddSpace('HelloWorld') // 'Hello World'
 * splitAtUppercaseAndAddSpace('HelloMyWorld') // 'Hello My World'
 */
export const splitAtUppercaseAndAddSpace = (str: string) =>
  str.split(/(?=[A-Z])/).join(' ')
